import { Clock } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

/**
 * Honest placeholder for a widget whose data feed isn't wired up yet. Renders a
 * labelled "Coming soon" card instead of fake data — used for the per-tenant
 * agent-activity feed and the health-score trend chart, both gated on TMA-601.
 */
export function DeferredWidgetCard({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <Card className="border border-dashed border-cmd-highest">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-start gap-3 py-2">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-cmd-outline" aria-hidden="true" />
          <div className="space-y-1">
            <p className="font-label text-xs uppercase tracking-wider text-cmd-outline">
              Coming soon — needs telemetry feed (TMA-601)
            </p>
            <p className="text-sm text-cmd-outline/80">{description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
